﻿'use strict'
import { App, Controller } from '../config/app.js'
import month from '../constants/month.js'
import { hasRole, currentStore, loadScript } from '../helper.js'

class CheckoutController extends Controller
{
	async index()
	{
		if (!window.Stripe && hasRole('Patient'))
		{
			await loadScript('https://js.stripe.com/v2/')
			Stripe.setPublishableKey(currentStore('stripeApiKey'))
		}

		// #region Pre-render the form to make it appear to load faster
		//App.Store.modelCreate('checkout', App.Config.customerId, {})
		//App.Store.loading('checkout', true)
		//this.view.render()
		// #endregion Pre-render

		return Promise.all(
			[
				App.Store.sync(month),
				App.Store.fetch('country', 0, { include: 'stateProvince' }),
				App.Store.fetch('checkout', App.Config.customerId)
			])
			.catch(() => App.Router.navigate('/cart'))
			.finally(() => this.view.render())
	}

	/*
	async express()
	{
		return App.Store.fetch('checkout', App.Config.customerId)
			.catch(() => App.Router.navigate('/cart'))
			.finally(() => this.view.render())
	}
	
	async review()
	{
		const checkout = await App.Store.model('checkout', App.Config.customerId)
		if (!checkout?.attributes)
			return App.Router.navigate(App.Store.model('route','plugin.apex.ui.checkout').attributes.url)
		this.view.model.sync({ order: checkoutToOrder(checkout) })
		console.info('/checkout/review', this.view.model)
	}
	*/

	async completed(orderId)
	{
		const topicName = 'Apex.Checkout.Completed' + (hasRole('Patient') ? '.Patient' : '')
		const topic = await App.Store.fetch('topic', topicName)

		if (App.Store.model('order', orderId)?.id) // Don't fetch the order if we already if (typical for redirect after order creation)
		{
			this.view.model.orderId = orderId
			this.view.model.messageTitle = topic.attributes.title
			this.view.model.messageBody = topic.attributes.body
		}
		else
		{
			return App.Store.fetch('order', orderId) // Typical if the page is refreshed
				.catch(err => console.error(err))
				.finally(() =>
				{
					this.view.model.orderId = orderId
					this.view.model.messageTitle = topic.attributes.title
					this.view.model.messageBody = topic.attributes.body
				})
		}
	}
}

export { CheckoutController }
